/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Addphotosorfiles3Inputs */

const zh_chat_addphotosorfiles3 = /** @type {(inputs: Chat_Addphotosorfiles3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加图片或文件`)
};

const en_chat_addphotosorfiles3 = /** @type {(inputs: Chat_Addphotosorfiles3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add photos or files`)
};

const es_chat_addphotosorfiles3 = /** @type {(inputs: Chat_Addphotosorfiles3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar fotos o archivos`)
};

/**
* | output |
* | --- |
* | "Add photos or files" |
*
* @param {Chat_Addphotosorfiles3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_addphotosorfiles3 = /** @type {((inputs?: Chat_Addphotosorfiles3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Addphotosorfiles3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_addphotosorfiles3(inputs)
	if (locale === "en") return en_chat_addphotosorfiles3(inputs)
	return es_chat_addphotosorfiles3(inputs)
});
export { chat_addphotosorfiles3 as "chat_addPhotosOrFiles" }